import { ReactNode } from 'react';
import ChunkErrorBoundary from './ChunkErrorBoundary';

interface BoundedElementProps {
  path: string;
  element: ReactNode;
}

const BoundedElement = ({ path, element }: BoundedElementProps) => (
  <ChunkErrorBoundary routeName={path}>{element}</ChunkErrorBoundary>
);

export default BoundedElement;
